<template>
    <b-tab title-link-class="p-0" lazy>
        <template v-slot:title>
            <b-nav-item-dropdown>
                <template slot="button-content">
                    <i class="cus-folder-picture"></i>
                    Documents
                </template>

                <b-dropdown-item
                    v-if="_hasAccess('patient.letter.view')"
                    @click="displayList(DOCUMENTTYPES.LETTERS)"
                >
                    <i class="cus-page-white-text"></i>View Letters
                    <span v-if="counts.letter"> ({{ counts.letter }}) </span>
                </b-dropdown-item>

                <b-dropdown-item
                    v-if="_hasAccess('patient.attachment.view')"
                    @click="displayList(DOCUMENTTYPES.ATTACHMENTS)"
                >
                    <i class="cus-page-attach"></i>View Attachments
                    <span v-if="counts.attachment">
                        ({{ counts.attachment }})
                    </span>
                </b-dropdown-item>
                <b-dropdown-item @click="displayList(DOCUMENTTYPES.WEBFORMS)">
                    <i class="cus-application-form-edit"></i>View Forms
                    <span v-if="counts.webform"> ({{ counts.webform }}) </span>
                </b-dropdown-item>

                <b-dropdown-item
                    @click="displayList(DOCUMENTTYPES.CERTIFICATES)"
                >
                    <i class="cus-page-white-medal"></i>View Certificates
                    <span v-if="counts.certificate">
                        ({{ counts.certificate }})
                    </span>
                </b-dropdown-item>

                <div class="dropdown-divider" v-if="!statusInActive"></div>

                <b-dropdown-item
                    v-if="
                        !statusInActive && _hasAccess('patient.letter.create')
                    "
                    @click.stop="openModal('modalNewLetter')"
                >
                    <i class="cus-add"></i> New Letter
                </b-dropdown-item>

                <b-dropdown-item
                    v-if="
                        _hasAccess('patient.attachment.view') &&
                        _hasAccess('patient.attachment.create') &&
                        !statusInActive
                    "
                    @click.stop="openModal('modalNewAttachment')"
                >
                    <i class="cus-add"></i> New Attachment
                </b-dropdown-item>
                <b-dropdown-item
                    v-if="!statusInActive"
                    @click.stop="openModal('modalNewWebform')"
                >
                    <i class="cus-add"></i> New Form
                </b-dropdown-item>
                <dropdown-nested
                    v-if="
                        _hasAccess('patient.certificate.email') ||
                        _hasAccess('patient.certificate.print')
                    "
                    :title="{ text: 'New Certificates', icon: 'cus-add' }"
                    :list="newCertificateDropdown"
                    @trigger-function="newCertificate"
                />
            </b-nav-item-dropdown>
        </template>

        <b-card-text>
            <letters
                v-if="selectedOption === DOCUMENTTYPES.LETTERS"
                @updateCounts="updateCounts"
                @getTabCounts="getTabCounts"
                :key="keyview"
                :patientId="patientId"
            />
            <attachments
                v-if="selectedOption === DOCUMENTTYPES.ATTACHMENTS"
                @updateCounts="updateCounts"
                :key="keyview"
                :patientDetails="patientDetails"
                v-on="$listeners"
            />
            <webforms
                v-if="selectedOption == DOCUMENTTYPES.WEBFORMS"
                @updateCounts="updateCounts"
                @getTabCounts="getTabCounts"
                :key="keyview"
                module="patient"
                :patientId="patientId"
            />
            <certificates
                v-if="selectedOption == DOCUMENTTYPES.CERTIFICATES"
                @updateCounts="updateCounts"
                @getTabCounts="getTabCounts"
                :key="keyview"
                :patientId="patientId"
            />
        </b-card-text>
    </b-tab>
</template>
<script>
import PatientDocument from "@/services/patient-documents";
import Letters from "@/components/patient-documents/document-list-letters";
import Attachments from "@/components/patient-documents/document-list-attachments";
import Webforms from "@/components/webform/document-list-webforms";
import Certificates from "@/components/patient-certificates/document-list-certificates";
import DropdownNested from "@/components/elements/dropdown/dropdown-nested";

const DOCUMENTTYPES = {
    ATTACHMENTS: "ATTACHMENTS",
    LETTERS: "LETTERS",
    WEBFORMS: "WEBFORMS",
    CERTIFICATES: "CERTIFICATES"
};

export default {
    components: {
        Attachments,
        Letters,
        Webforms,
        Certificates,
        DropdownNested
    },
    props: {
        patientDetails: {
            type: Object
        },
        openList: {
            default: null
        }
    },
    data() {
        return {
            keyview: 0,
            selectedOption: DOCUMENTTYPES.ATTACHMENTS,
            counts: {},
            DOCUMENTTYPES,
            newCertificateDropdown: [
                {
                    text: "Email Certificate",
                    icon: "cus-email",
                    function_code: "EMAIL_CERT",
                    isModal: true
                },
                {
                    text: "Print Certificate",
                    icon: "cus-printer",
                    function_code: "PRINT_CERT",
                    isModal: true
                }
            ]
        };
    },
    computed: {
        statusInActive() {
            return this.$store.getters["patient/statusInActive"];
        },
        patientId() {
            return this.patientDetails ? this.patientDetails.id : null;
        }
    },
    watch: {
        openList: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.displayList(newValue);
                }
            }
        }
    },
    mounted() {
        this.getTabCounts();
    },
    methods: {
        getTabCounts(timeOut = 500) {
            setTimeout(() => {
                PatientDocument.getTabCounts(this.patientId).then(res => {
                    if (res && res.meta) {
                        this.updateCounts({
                            all: res.meta.count.all_count.toString(),
                            attachment: res.meta.count.attachment_count.toString(),
                            letter: res.meta.count.letter_count.toString(),
                            webform: res.meta.count.webform_count.toString(),
                            certificate: res.meta.count.certificate_count.toString()
                        });
                    }
                });
            }, timeOut);
        },
        displayList(code) {
            this.getTabCounts();
            this.keyview += 1; // force re-render if same menu item is selected
            this.selectedOption = code;
        },
        updateCounts({ all, attachment, letter, webform, certificate }) {
            this.counts = {
                all: all || 0,
                attachment: attachment || 0,
                letter: letter || 0,
                webform: webform || 0,
                certificate: certificate || 0
            };
        },
        openModal(ref) {
            if (ref === "modalNewLetter") {
                this.$store.commit("patient/openModalNewLetter");
            } else if (ref === "modalNewAttachment") {
                this.$store.commit("patient/openModalNewAttachment");
            } else if (ref === "modalNewWebform") {
                this.$parent.$parent.$refs["modalNewWebform"].open();
            }
        },
        newCertificate(ref) {
            if (ref === "EMAIL_CERT") {
                this.$parent.$parent.$parent.$refs[
                    "modalEmailCertificate"
                ].open();
            } else if (ref === "PRINT_CERT") {
                this.$parent.$parent.$parent.$refs[
                    "modalPrintCertificate"
                ].open();
            }
        }
    }
};
</script>
